import { err, ok, Result } from "neverthrow";
import GraphqlApiError from "@/framework/network/gql/GraphqlApiError";
import { QcBizResponder, QcBizResponderSchema } from "@/modules/staff/objects/QcBizResponder";
import { GraphqlApi, IGraphqlApi } from "@/framework/network/gql/GraphqlApi";
import {
  GetStaffMyselfDocument,
  GetStaffMyselfQuery,
  ListRespondersDocument,
  ListRespondersQuery,
} from "@/framework/network/gql/generated/graphql";
import { CustomGetStaffMyselfState } from "@/framework/network/gql/custom/GetStaffMyself/CustomGetStaffMyselfState";
import { CustomGetStaffMyselfSimple } from "@/framework/network/gql/custom/GetStaffMyself/CustomGetStaffMyselfSimple";
import { QcBizStaff, StaffMyself, StaffMyselfSchema } from "@/modules/staff/objects/Staff";

export class StaffService {
  private _graphql: IGraphqlApi;

  public constructor(graphql: IGraphqlApi = new GraphqlApi()) {
    this._graphql = graphql;
  }

  async fetchResponders(): Promise<Result<QcBizResponder[], GraphqlApiError>> {
    const res = await this._graphql.runQueryAndValidate<ListRespondersQuery, QcBizResponder[]>(
      // @ts-ignore conflict between generic typing and exact requirement
      ListRespondersDocument,
      QcBizResponderSchema,
      {}
    );
    return res.isErr() ? err(res.error) : ok(res.value);
  }

  async getStaffMyselfState(): Promise<Result<QcBizStaff, GraphqlApiError>> {
    const res = await this._graphql.runQuery(CustomGetStaffMyselfState, {});
    return res.isErr() ? err(res.error) : ok(res.value);
  }

  async getBasicStaffDetails(variables: any): Promise<Result<StaffMyself, GraphqlApiError>> {
    const res = await this._graphql.runQuery(CustomGetStaffMyselfSimple, variables);
    return res.isErr() ? err(res.error) : ok(res.value.getStaffMyself);
  }

  // it seems that, by and large, only a very small subset of the data is used, but keeping this as an option
  async getStaffDetailsWithLocationAndMenus(variables: any): Promise<Result<StaffMyself, GraphqlApiError>> {
    const res = await this._graphql.runQueryAndValidate<GetStaffMyselfQuery, StaffMyself>(
      GetStaffMyselfDocument,
      StaffMyselfSchema,
      variables
    );
    return res.isErr() ? err(res.error) : ok(res.value);
  }
}
